"use client";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMarkedReadIds,
  getMarkedReadQueryKey,
} from "@/features/notifications/utils/notification-read-state";

export const useMarkedReadNotificationIds = (userId: number) => {
  const queryClient = useQueryClient();

  return useQuery<string[]>({
    queryKey: getMarkedReadQueryKey(userId),
    queryFn: () => getMarkedReadIds(queryClient, userId),
    enabled: userId > 0,
    initialData: () => getMarkedReadIds(queryClient, userId),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
};
